export default __webpack_public_path__ + "static/media/logging.8777da21.svg";